import { render } from "./PlaceholderSelect.vue?vue&type=template&id=5facca94&scoped=true&ts=true"
import script from "./PlaceholderSelect.vue?vue&type=script&lang=ts"
export * from "./PlaceholderSelect.vue?vue&type=script&lang=ts"

import "./PlaceholderSelect.vue?vue&type=style&index=0&id=5facca94&scoped=true&lang=css"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5facca94"]])

export default __exports__